import { IAppState } from '../reducers';

export const getCommonState = (state: IAppState) => state.common;
